import React from 'react';
import { Provider } from 'react-redux';
import { Switch, Route } from 'react-router';
import { ToastContainer } from 'react-toastify';
import { ConnectedRouter } from 'react-router-redux';
import ReactGA from 'react-ga';

import MainLayout from './layouts/Main/MainLayout';
import createApplicationStore from './store/createApplicationStore';
import { history } from './store/createRootReducer';
import CONFIG from './config/config';

import HomeContainer from './containers/HomeContainer';
import SignInContainer from './containers/SignInContainer';
import SignUpContainer from './containers/SignUpContainer';
import ResetPasswordContainer from './containers/ResetPasswordContainer';
import ChangePasswordContainer from './containers/ChangePasswordContainer';
import CompanyContainer from './containers/CompanyContainer';
import ProfileContainer from './containers/ProfileContainer';
import DeveloperApiRoute from './routes/DeveloperApiRoute';
import RedirectRoute from './routes/RedirectRoute';
import LandingComponent from './components/landing/LandingComponent';
import UsecasesComponent from './components/usecases/UsecasesComponent';
import WelcomeComponent from './components/welcome/WelcomeComponent';
import SignInSupportContainer from './containers/SignInSupportContainer';
import AdminPageContainer from './containers/AdminPageContainer';
import MarketingGuidelinesComponent from './components/marketingGuidelines/marketingGuidelinesComponent';
import GuidesComponent from './components/guides/GuidesComponent';
import {
    LANDING_PATH,
    SIGN_IN_PATH,
    SIGN_UP_PATH,
    HOME_PATH,
    RESET_PASSWORD_PATH,
    CHANGE_PASSWORD_PATH,
    INVITE_PATH,
    OLD_INVITE_PATH,
    ADD_COMPANY_PATH,
    USECASES_PATH,
    WELCOME_PATH,
    SUPPORT_AUTH_PATH,
    ADMIN_PATH,
} from './constants/routes';

import AuthRoute from './routes/AuthRoute';

const store = createApplicationStore();

class App extends React.Component {
    componentDidMount() {
        ReactGA.initialize(CONFIG.GA_ANALYTICS);
        ReactGA.set({ page: window.location.pathname });
        ReactGA.pageview(window.location.pathname);
    }

    render() {
        return (
            <div className="App">
                <ToastContainer
                    position="top-center"
                    autoClose={8000}
                    closeOnClick={false}
                    hideProgressBar
                    pauseOnHover={false}
                    className="custom-toast-container"
                    toastClassName="custom-toast"
                    bodyClassName="custom-toast-body"
                />
                <Provider store={store}>
                    <ConnectedRouter history={history}>
                        <MainLayout>
                            <Switch>
                                <Route exact path={LANDING_PATH} component={LandingComponent} />
                                <Route path={SIGN_IN_PATH} component={SignInContainer} />
                                <Route path={SIGN_UP_PATH} component={SignUpContainer} />
                                <Route path={SUPPORT_AUTH_PATH} component={SignInSupportContainer} />
                                <Route path={RESET_PASSWORD_PATH} component={ResetPasswordContainer} />
                                <Route path={'/:companyId' + INVITE_PATH} component={ChangePasswordContainer} />
                                <Route path={'/:companyId' + OLD_INVITE_PATH} component={ChangePasswordContainer} />
                                <Route path={CHANGE_PASSWORD_PATH} component={ChangePasswordContainer} />
                                <AuthRoute path={USECASES_PATH} needAuth={false} component={UsecasesComponent} />
                                <AuthRoute path={WELCOME_PATH} component={WelcomeComponent} />
                                <AuthRoute path={HOME_PATH} component={HomeContainer} />
                                <AuthRoute path={ADD_COMPANY_PATH} component={CompanyContainer} />
                                <AuthRoute path='/marketing/:menuItem?' component={MarketingGuidelinesComponent} />
                                <AuthRoute path='/profile/:menuItem?' component={ProfileContainer} />
                                <AuthRoute path='/api/:api/:menuItem?/:subMenuItem?' needAuth={false} component={DeveloperApiRoute} />
                                <AuthRoute path='/guides/:menuItem?/' needAuth={false} component={GuidesComponent} />
                                <AuthRoute path={ADMIN_PATH} component={AdminPageContainer} />
                                <RedirectRoute />
                            </Switch>
                        </MainLayout>
                    </ConnectedRouter>
                </Provider>
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js